import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { CampaignsPageStore } from 'pages/campaigns/store/campaignsPageStore'
import { CampaignsPageContext } from 'pages/campaigns/context/context'

export const CampaignLayout = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const entities = useEntitiesContext()
  const pageStore = useMemo(
    () => new CampaignsPageStore(menuLayoutStore.pageLayoutStore, entities),
    []
  )

  return (
    <CampaignsPageContext.Provider value={pageStore}>
      <Outlet />
    </CampaignsPageContext.Provider>
  )
})
